export const TimeType = {
  day: 'DAY',
  week: 'WEEK',
  month: 'MONTH',
  year: 'YEAR',
} as const;

export type TimeType = (typeof TimeType)[keyof typeof TimeType];

export const DisplayType = {
  chart: 'CHART',
  table: 'TABLE',
} as const;

export type DisplayType = (typeof DisplayType)[keyof typeof DisplayType];

export const getComponentStatus = ({ timeType, displayType }: { timeType: TimeType; displayType: DisplayType }) => {
  return {
    isYear: timeType === TimeType.year,
    isMonth: timeType === TimeType.month,
    isChart: displayType === DisplayType.chart,
    isTable: displayType === DisplayType.table,
  };
};

export const colors = [
  '#52E7FF',
  '#FF477B',
  '#FFCB47',
  '#6F47FF',
  '#16DD8E',
  '#2D8DFF',
  '#52C41A',
  '#234ED9',
  '#FF9247',
  '#854ECA',
  '#4A90E2',
  '#FF4D4F',
];
